export enum ConsultationType {
  ONLINE = "Online",
  OFFLINE = "Offline",
  Both = "Both",
}

export interface Doctor {
  id: string;
  name: string;
  avatar?: string;
  specialization: string;
  qualification: string;
  experience: string;
  phone: string;
  email: string;
  status: "active" | "onLeave";
  appointmentsCount: number;
  nextAvailable: string;
}

export interface DoctorDetailsType {
  userId: string;
  name: string;
  about: string;
  mobileNumber: string;
  registrationNumber: string;
  profileImage: File | string;
  signatureImage: File | string;
  education: string;
  username: string;
  password: string;
  role: string;
  experience: number;
  opRate: number;
  specialization: string[];
  hospitalName: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  amount?: number;
  iaAvailability: boolean;
  lat: string;
  long: string;
  languages: string[];
  specialities: string[];
  isMonthly?: boolean;
  consultationType?: ConsultationType;
  isDecommissioned?: boolean;
  firstName?: string;
  lastName?: string;
}
export interface ClinicDetailsType {
  id: string;
  name: string;
  mobileNumber: string;
  profileImage: File | string;
  registrationNumber: string;
  drugLicenseNumber: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  username: string;
  password: string;
  supervisorName: string;
  lat: string;
  long: string;
  fssaiNumber?: string;
}

export interface SupervisiorDetailsType {
  userId: string;
  name: string;
  mobileNumber: string;
  profileImage: File | string;
  role: string;
  education: string;
  username: string;
  password: string;
}
